import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDlztSaDP3yLLCDAcJZWRAsIVNPCEn7PNQ",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "painel.duzzsystem.com.br",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "gold-obelisk-474722-t3",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "gold-obelisk-474722-t3.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "500930429533",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:500930429533:web:8353e2a86bf1b56c6b83b4",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-LD70RD631D"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Conecta aos emuladores apenas quando executando localmente (localhost ou 127.0.0.1)
const isLocalhost = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
);

if (process.env.REACT_APP_USE_EMULATOR === "true" && isLocalhost) {
    const host = process.env.REACT_APP_EMULATOR_HOST || "localhost";
    connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
    connectFirestoreEmulator(db, host, 8680);
    connectStorageEmulator(storage, host, 9199);
    console.log("🔥 [Firebase] Conectado aos Emuladores Locais (Auth: 9099, Firestore: 8680, Storage: 9199)");
}